<div class="SimpleCard__Wrapper"><ng-content></ng-content></div>
